import { OrganizationRole } from 'src/context/types';
import { RoleGated } from '../types';

export interface SettingEntry extends RoleGated {
  id: string;
  /** i18n key under `globalSearch.entries`. */
  labelKey: string;
  /** Leaf path passed to buildPath(); never starts with a slash. */
  path: string;
}

const ALL: OrganizationRole[] = ['owner', 'admin', 'member'];
const MANAGERS: OrganizationRole[] = ['owner', 'admin'];
// Mirrors `canManageRestaurantSettings` (see `useAuthPermissions`), which is `isOwner ||
// isPlatformAdmin` — org admins are deliberately excluded, unlike `canManageOrg`/MANAGERS.
const RESTAURANT_SETTINGS_MANAGERS: OrganizationRole[] = ['owner'];

export const SETTINGS_INDEX: SettingEntry[] = [
  { id: 'profile.account', labelKey: 'profileAccount', path: 'profile', roles: ALL },
  { id: 'org.general', labelKey: 'orgGeneral', path: 'settings/organization', roles: MANAGERS },
  { id: 'org.members', labelKey: 'orgMembers', path: 'settings/organization/members', roles: MANAGERS },
  { id: 'org.invitations', labelKey: 'orgInvitations', path: 'settings/organization/invitations', roles: MANAGERS },
  { id: 'org.audit', labelKey: 'orgAuditLog', path: 'settings/organization/audit', roles: MANAGERS },
  {
    id: 'restaurant.info',
    labelKey: 'restaurantInformation',
    path: 'settings/restaurant',
    roles: RESTAURANT_SETTINGS_MANAGERS,
  },
  {
    id: 'restaurant.branches',
    labelKey: 'restaurantBranches',
    path: 'settings/restaurant/branches',
    roles: RESTAURANT_SETTINGS_MANAGERS,
  },
  {
    id: 'restaurant.tables',
    labelKey: 'restaurantTables',
    path: 'settings/restaurant/tables',
    roles: RESTAURANT_SETTINGS_MANAGERS,
  },
  {
    id: 'restaurant.timesheets',
    labelKey: 'timesheetSettings',
    path: 'settings/restaurant/timesheets',
    roles: RESTAURANT_SETTINGS_MANAGERS,
  },
  { id: 'menu.settings', labelKey: 'menuSettings', path: 'settings/menu', roles: RESTAURANT_SETTINGS_MANAGERS },
  {
    id: 'accounting.categories',
    labelKey: 'transactionCategories',
    path: 'settings/accounting/categories',
    roles: RESTAURANT_SETTINGS_MANAGERS,
  },
];

export function visibleSettings(role: OrganizationRole | null, isPlatformAdmin: boolean): SettingEntry[] {
  if (isPlatformAdmin) return SETTINGS_INDEX;
  if (!role) return [];
  return SETTINGS_INDEX.filter((entry) => entry.roles.includes(role));
}
